/*
 * Copyright (c) 2005, The haXe Project Contributors
 * All rights reserved.
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 *   - Redistributions of source code must retain the above copyright
 *     notice, this list of conditions and the following disclaimer.
 *   - Redistributions in binary form must reproduce the above copyright
 *     notice, this list of conditions and the following disclaimer in the
 *     documentation and/or other materials provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY THE HAXE PROJECT CONTRIBUTORS "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE HAXE PROJECT CONTRIBUTORS BE LIABLE FOR
 * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
 * LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY
 * OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH
 * DAMAGE.
 */
/**
 * package: haxe
 * class: Unserializer
 * root Object
 * @constructor
 */
haxe.Unserializer = function(buf) {
	this.buf = buf;
	this.length = buf.length;
	this.pos = 0;
	this.scache = [];
	this.cache = [];

	/** @type {haxe.TypeResolver} */
	var r = haxe.Unserializer.DEFAULT_RESOLVER;
	if(r == null) {
		r = Type;
		haxe.Unserializer.DEFAULT_RESOLVER = r;
	}
	this.setResolver(r);
};
$hxClasses['haxe.Unserializer'] = haxe.Unserializer;
/** @private @type {Array} */
haxe.Unserializer.__name__ = ["haxe","Unserializer"];

/**
 * initCodes
 *
 * $type TFun([],TInst(Array,[TInst(Int,[])]))
 * static function initCodes()
 * @private
 * @static
 * @return {Array}
 */
haxe.Unserializer.initCodes = function() {
	/** @type {Array} */
	var codes = [];
	/** @type {number} */
	var _g1 = 0;
	/** @type {number} */
	var _g = haxe.Unserializer.BASE64.length;
	while(_g1 < _g) {
		/** @type {number} */
		var i = _g1++;
		codes[haxe.Unserializer.BASE64.charCodeAt(i)] = i;
	}
	return codes;
};


/**
 * run
 * Unserialize a single value and return it.
 * *
 * --------------------- *
 *
 * $type TFun([{ name => v, t => TInst(String,[]), opt => false }],TDynamic(null))
 * @public
 * @static
 * @param {string}  v 
 * @return {null}
 */
haxe.Unserializer.run = function(v) {
	return new haxe.Unserializer(v).unserialize();
};


/**
 * unserialize
 *
 * $type TFun([],TDynamic(null))
 * @public
 * @this haxe.Unserializer
 * @return {Object}
 */
haxe.Unserializer.prototype.unserialize = function() {
	/** @type {number} */
	var c;
	/** @type {number} */
	var len;
	/** @type {string} */
	var s;
	/** @type {number} */
	var n;
	/** @type {Object} */
	var o;
	/** @type {string} */
	var name;
	/** @type {Class} */
	var cl;
	/** @type {Enum} */
	var edecl;
	/** @type {Enum} */
	var e;
	/** @type {number} */
	var i;
	switch (this.buf.charCodeAt(this.pos++)) {
		case 110:
			return null;
		case 116:
			return true;
		case 102:
			return false;
		case 122:
			return 0;
		case 105:
			return this.readDigits();
		case 100:
			/** @type {number} */
			var p1 = this.pos;
			while (true) {
				c = this.buf.charCodeAt(this.pos);
				/*  + - . , 0-9 */
				if (c >= 43 && c < 58 || c == 101 || c == 69) this.pos++; else break;
			}
			return Std.parseFloat(HxOverrides.substr(this.buf, p1, this.pos - p1));
		case 121:
			len = this.readDigits();
			if (this.buf.charCodeAt(this.pos++) != 58 || this.length - this.pos < len) throw "Invalid string length";
			s = HxOverrides.substr(this.buf, this.pos, len);
			this.pos += len;
			s = StringTools.urlDecode(s);
			this.scache.push(s);
			return s;
		case 107:
			return Math.NaN;
		case 109:
			return Math.NEGATIVE_INFINITY;
		case 112:
			return Math.POSITIVE_INFINITY;
		case 97:
			/** @type {Array} */
			var a = [];
			this.cache.push(a);
			while (true) {
				c = this.buf.charCodeAt(this.pos);
				if (c == 104) {
					this.pos++;
					break;
				}
				if (c == 117) {
					this.pos++;
					n = this.readDigits();
					a[a.length + n - 1] = null;
				} else a.push(this.unserialize());
			}
			return a;
		case 111:
			o = {};
			this.cache.push(o);
			this.unserializeObject(o);
			return o;
		case 114:
			n = this.readDigits();
			if (n < 0 || n >= this.cache.length) throw "Invalid reference";
			return this.cache[n];
		case 82:
			n = this.readDigits();
			if (n < 0 || n >= this.scache.length) throw "Invalid string reference";
			return this.scache[n];
		case 120:
			throw this.unserialize();
		case 99:
			name = this.unserialize();
			cl = this.resolver.resolveClass(name);
			if (cl == null) throw "Class not found " + name;
			o = Type.createEmptyInstance(cl);
			this.cache.push(o);
			this.unserializeObject(o);
			return o;
		case 119:
			name = this.unserialize();
			edecl = this.resolver.resolveEnum(name);
			if (edecl == null) throw "Enum not found " + name;
			e = this.unserializeEnum(edecl, this.unserialize());
			this.cache.push(e);
			return e;
		case 106:
			name = this.unserialize();
			edecl = this.resolver.resolveEnum(name);
			if (edecl == null) throw "Enum not found " + name;
			this.pos++;
			/* skip ':' */
			/** @type {number} */
			var index = this.readDigits();
			/** @type {string} */
			var tag = Type.getEnumConstructs(edecl)[index];
			if (tag == null) throw "Unknown enum index " + name + "@" + index;
			e = this.unserializeEnum(edecl, tag);
			this.cache.push(e);
			return e;
		case 108:
			/** @type {List} */
			var l = new List();
			this.cache.push(l);
			while (this.buf.charCodeAt(this.pos) != 104) l.add(this.unserialize());
			this.pos++;
			return l;
		case 98:
			/** @type {Hash} */
			var h = new Hash();
			this.cache.push(h);
			while (this.buf.charCodeAt(this.pos) != 104) {
				s = this.unserialize();
				h.set(s, this.unserialize());
			}
			this.pos++;
			return h;
		case 113:
			/** @type {IntHash} */
			var h1 = new IntHash();
			this.cache.push(h1);
			c = this.buf.charCodeAt(this.pos++);
			while (c == 58) {
				i = this.readDigits();
				h1.set(i, this.unserialize());
				c = this.buf.charCodeAt(this.pos++);
			}
			if (c != 104) throw "Invalid IntHash format";
			return h1;
		case 118:
			/** @type {Date} */
			var d = HxOverrides.strDate(HxOverrides.substr(this.buf, this.pos, 19));
			this.cache.push(d);
			this.pos += 19;
			return d;
		case 115:
			len = this.readDigits();
			/** @type {string} */
			var buf = this.buf;
			if (this.buf.charCodeAt(this.pos++) != 58 || this.length - this.pos < len) throw "Invalid bytes length";
			/** @type {Array} */
			var codes = haxe.Unserializer.CODES;
			if (codes == null) {
				codes = haxe.Unserializer.initCodes();
				haxe.Unserializer.CODES = codes;
			}
			i = this.pos;
			/** @type {number} */
			var rest = len & 3;
			/** @type {number} */
			var size = (len >> 2) * 3 + (rest >= 2 ? rest - 1 : 0);
			/** @type {number} */
			var max = i + (len - rest);
			/** @type {haxe.io.Bytes} */
			var bytes = haxe.io.Bytes.alloc(size);
			/** @type {number} */
			var bpos = 0;
			/** @type {number} */
			var c1;
			/** @type {number} */
			var c2;
			/** @type {number} */
			var c3;
			while (i < max) {
				c1 = codes[buf.charCodeAt(i++)];
				c2 = codes[buf.charCodeAt(i++)];
				bytes.b[bpos++] = (c1 << 2 | c2 >> 4) & 255;
				c3 = codes[buf.charCodeAt(i++)];
				bytes.b[bpos++] = (c2 << 4 | c3 >> 2) & 255;
				/** @type {number} */
				var c4 = codes[buf.charCodeAt(i++)];
				bytes.b[bpos++] = (c3 << 6 | c4) & 255;
			}
			if (rest >= 2) {
				c1 = codes[buf.charCodeAt(i++)];
				c2 = codes[buf.charCodeAt(i++)];
				bytes.b[bpos++] = (c1 << 2 | c2 >> 4) & 255;
				if (rest == 3) {
					c3 = codes[buf.charCodeAt(i++)];
					bytes.b[bpos++] = (c2 << 4 | c3 >> 2) & 255;
				}
			}
			this.pos += len;
			this.cache.push(bytes);
			return bytes;
		case 67:
			name = this.unserialize();
			cl = this.resolver.resolveClass(name);
			if (cl == null) throw "Class not found " + name;
			o = Type.createEmptyInstance(cl);
			this.cache.push(o);
			o.hxUnserialize(this);
			if (this.buf.charCodeAt(this.pos++) != 103) throw "Invalid custom data";
			return o;
		default:
	}
	this.pos--;
	throw "Invalid char " + this.buf.charAt(this.pos) + " at position " + this.pos;
};


/**
 * unserializeEnum
 *
 * $type TFun([{ name => edecl, t => TInst(Enum,[TMono(<mono>)]), opt => false },{ name => tag, t => TInst(String,[]), opt => false }],TMono(<mono>))
 * function unserializeEnum( edecl, tag )
 * @private
 * @this haxe.Unserializer
 * @param {Enum}  edecl 
 * @param {string}  tag 
 * @return {TMono(<mono>)}
 */
haxe.Unserializer.prototype.unserializeEnum = function(edecl,tag) {
	if(this.buf.charCodeAt(this.pos++) != 58) throw "Invalid enum format";
	/** @type {number} */
	var nargs = this.readDigits();
	if(nargs == 0) return Type.createEnum(edecl,tag);
	/** @type {Array} */
	var args = [];
	while(nargs-- > 0) args.push(this.unserialize());
	return Type.createEnum(edecl,tag,args);
};


/**
 * unserializeObject
 *
 * $type TFun([{ name => o, t => TAnonymous(<anonymous>), opt => false }],TEnum(Void,[]))
 * function unserializeObject(o)
 * @private
 * @this haxe.Unserializer
 * @param {TAnonymous(<anonymous>)}  o 
 * @return {void}
 */
haxe.Unserializer.prototype.unserializeObject = function(o) {
	while(true) {
		if(this.pos >= this.length) throw "Invalid object";
		if(this.buf.charCodeAt(this.pos) == 103) break;
		/** @type {Object} */
		var k = this.unserialize();
		if(!js.Boot.__instanceof(k,String)) throw "Invalid object key";
		/** @type {Object} */
		var v = this.unserialize();
		o[k] = v;
	}
	this.pos++;
};


/**
 * readDigits
 *
 * $type TFun([],TInst(Int,[]))
 * function readDigits()
 * @private
 * @this haxe.Unserializer
 * @return {number}
 */
haxe.Unserializer.prototype.readDigits = function() {
	/** @type {number} */
	var k = 0;
	/** @type {boolean} */
	var s = false;
	/** @type {number} */
	var fpos = this.pos;
	while(true) {
		/** @type {number} */
		var c = this.buf.charCodeAt(this.pos);
		if(c != c) break;
		if(c == 45) {
			if(this.pos != fpos) break;
			s = true;
			this.pos++;
			continue;
		}
		if(c < 48 || c > 57) break;
		k = k * 10 + (c - 48);
		this.pos++;
	}
	if(s) k *= -1;
	return k;
};


/**
 * get
 *
 * $type TFun([{ name => p, t => TInst(Int,[]), opt => false }],TInst(Int,[]))
 * @private
 * @this haxe.Unserializer
 * @param {number}  p 
 * @return {number}
 */
haxe.Unserializer.prototype.get = function(p) {
	return this.buf.charCodeAt(p);
};


/**
 * getResolver
 *
 * $type TFun([],TType(haxe.TypeResolver,[]))
 * public function getResolver()
 * @public
 * @this haxe.Unserializer
 * @return {haxe.TypeResolver}
 */
haxe.Unserializer.prototype.getResolver = function() {
	return this.resolver;
};


/**
 * setResolver
 *
 * $type TFun([{ name => r, t => TType(haxe.TypeResolver,[]), opt => false }],TEnum(Void,[]))
 * public function setResolver( r )
 * @public
 * @this haxe.Unserializer
 * @param {haxe.TypeResolver}  r 
 * @return {void}
 */
haxe.Unserializer.prototype.setResolver = function(r) {
	if(r == null) this.resolver = { resolveClass : function(_) {
		return null;
	}, resolveEnum : function(_) {
		return null;
	}}; else this.resolver = r;
};

/** @private @type {haxe.TypeResolver} */
haxe.Unserializer.prototype.resolver = null;
/** @private @type {Array} */
haxe.Unserializer.prototype.scache = null;
/** @private @type {Array} */
haxe.Unserializer.prototype.cache = null;
/** @private @type {number} */
haxe.Unserializer.prototype.length = null;
/** @private @type {number} */
haxe.Unserializer.prototype.pos = null;
/** @private @type {string} */
haxe.Unserializer.prototype.buf = null;
/** @type {haxe.Unserializer} */
haxe.Unserializer.prototype.__class__ = haxe.Unserializer;
/** @type {haxe.TypeResolver} */
haxe.Unserializer.DEFAULT_RESOLVER = Type;

/** @private @type {string} */
haxe.Unserializer.BASE64 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789%:";

/** @private @type {Array} */
haxe.Unserializer.CODES = null;

